/**
 * Bridges the two date conventions in play when editing a todo's due date:
 *
 * - The domain `Todo.dueDate` is a LOCAL-midnight `Date` (see `core/domain/Todo.ts` `parseDueDate`).
 * - The shared `DatePicker` / `Calendar` primitive works in UTC-midnight `Date`s (`todayUtc`,
 *   `toIsoDate`) to match the backend's `YYYY-MM-DD` `LocalDate` boundary.
 *
 * Converting on the calendar-day fields (not the absolute instant) keeps the same Y/M/D and
 * avoids the UTC-offset off-by-one that would otherwise skew the selected day.
 */

/** Local-midnight (domain) → UTC-midnight (picker), preserving the calendar day. */
export function domainDateToPicker(local: Date): Date {
  return new Date(Date.UTC(local.getFullYear(), local.getMonth(), local.getDate()));
}

/** UTC-midnight (picker) → local-midnight (domain), preserving the calendar day. */
export function pickerDateToDomain(utc: Date): Date {
  return new Date(utc.getUTCFullYear(), utc.getUTCMonth(), utc.getUTCDate());
}
